<template>
  <div v-if="user" class="section signature-block">
    <div class="row">
      <div class="col-8">
        <h4 class="font-light">{{ role }}: {{ user.full_name }}</h4>
        By signing this record I, {{ user.full_name }}, am certifying that:
        <ul>
          <li v-for="(item, idx) in getText()" :key="`item-${idx}`">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="col-4">
        <h6 class="font-light">Instructions</h6>
        To sign the record, enter your <strong>Signature Code</strong> into the
        field below and click <i>Sign</i>.<br />
        <label class="font-bold u-no-margin">Signature Code</label>
        <div class="form-group">
          <input
            type="password"
            v-model="code"
            class="form-group-input"
            v-bind:class="{ 'input-error': error }"
            placeholder="******"
          />
          <button
            class="form-group-btn btn-dark"
            v-on:click="$emit('sign', role, code)"
          >
            <i class="fa-wrapper fa fa-lock pad-right"></i>Sign
          </button>
        </div>
        <span class="error">{{ error }}</span>
      </div>
    </div>
  </div>
</template>
<style>
.signature-block {
  border: 2px solid #d5d7dc;
  background: #f8f9fa;
  box-shadow: 3px 3px 2px #d5d7dc;
}
.signature-block ul li {
  line-height: 1.66rem;
}
.form-group-input {
  max-width: 60%;
}
</style>
<script>
export default {
  name: "signature-form",
  props: ["user", "role", "error"],
  data: function() {
    return {
      code: "",
      text: {
        candidate: [
          "The record reflects my own work and achievements during this task; and",
          "I have been made aware of the assessments recorded and the overall result of this record."
        ],
        instructor: [
          "The task was completed under the required supervision/conditions; and",
          "The assessment awarded and overall result, as shown on this page, are correct; and",
          "The candidate has been advised of the result of this task."
        ]
      }
    };
  },
  methods: {
    getText() {
      if (this.role == "candidate" || this.role == "Candidate") {
        return this.text.candidate;
      } else {
        return this.text.instructor;
      }
    }
  }
};
</script>
